function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1872 11.4713H12.9772L17.2172 15.7313C17.6272 16.1413 17.6272 16.8113 17.2172 17.2213C16.8072 17.6313 16.1372 17.6313 15.7272 17.2213L11.4772 12.9713V12.1813L11.2072 11.9013C9.80719 13.1013 7.89719 13.7213 5.86719 13.3813C3.08719 12.9113 0.867188 10.5913 0.527188 7.79133C0.00718811 3.56133 3.56719 0.00132874 7.79719 0.521329C10.5972 0.861329 12.9172 3.08133 13.3872 5.86133C13.7272 7.89133 13.1072 9.80133 11.9072 11.2013L12.1872 11.4713ZM2.47719 6.97133C2.47719 9.46133 4.48719 11.4713 6.97719 11.4713C9.46719 11.4713 11.4772 9.46133 11.4772 6.97133C11.4772 4.48133 9.46719 2.47133 6.97719 2.47133C4.48719 2.47133 2.47719 4.48133 2.47719 6.97133Z",
  fill: "#383838"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dbce7b70.svg";
export { ForwardRef as ReactComponent };